import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _entriesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/entries";
import Vue from "vue";
import { cloneDeep, get, isArray, isEmpty, merge, set } from "lodash";
import { EmptyApplication } from "@Shared/@DataFiles/empty-application";
import { decodeToken, ignoreTransformWith } from "@Shared/@Utils/utils";
import { CLIENT_APPLICATION_STATUS } from "@Shared/js/enum";
import { VueSetWithPath } from "./application-standalone-helpers";
export const SET_APPLICATION = "SET_APPLICATION";
export const SET_CURRENT_APPLICATION_ID = "SET_CURRENT_APPLICATION_ID";
export const SET_CURRENT_APPLICATION = "SET_CURRENT_APPLICATION";
export const SET_FIELD_BY_PATH = "SET_FIELD_BY_PATH";
export const ADD_ARRAY_FIELD_BY_PATH = "ADD_ARRAY_FIELD_BY_PATH";
export const DELETE_ARRAY_FIELD_BY_PATH = "DELETE_ARRAY_FIELD_BY_PATH";
export const SET_CURRENT_APPLICATION_SCHEMA = "SET_CURRENT_APPLICATION_SCHEMA";
export const SET_CURRENT_COMPUTED_SCHEMA = "SET_CURRENT_COMPUTED_SCHEMA";
export const SET_CURRENT_COMPUTED_SCHEMA_BY_PATH = "SET_CURRENT_COMPUTED_SCHEMA_BY_PATH";
export const SET_DISCLAIMERS = "SET_DISCLAIMERS";
export const SET_APPLICATION_METADATA = "SET_APPLICATION_METADATA";
export const SET_APPLICATION_SOURCE_TYPE = "SET_APPLICATION_SOURCE_TYPE";
export const SET_APPLICATION_FLOW = "SET_APPLICATION_FLOW";
export const CLEAR_ALL_SINS = "CLEAR_ALL_SINS";
export const MARK_APPLICATION_AS_SUBMITTED = "MARK_APPLICATION_AS_SUBMITTED";
export const RESET_SUBJECT_PROPERTY_EXISTING_MORTGAGES = "RESET_SUBJECT_PROPERTY_EXISTING_MORTGAGES";
export const RESET_OTHER_PROPERTIES_EXISTING_MORTGAGES = "RESET_OTHER_PROPERTIES_EXISTING_MORTGAGES";
export const SET_ACCEPTED_CONSENTS = "SET_ACCEPTED_CONSENTS";
export const SET_TOKEN_DATA = "SET_TOKEN_DATA";
export const SET_CLIENT_DETAILS = "SET_CLIENT_DETAILS";
export const SET_IS_FILL_OUT = "SET_IS_FILL_OUT";
export const SET_CONSOLIDATED_REQUEST = "SET_CONSOLIDATED_REQUEST";
export const SET_LOADING = "SET_LOADING";
export const SET_ADDITIONAL_INFORMATION = "SET_ADDITIONAL_INFORMATION";
export const SET_CURRENT_APPLICATION_CHANGES = "SET_CURRENT_APPLICATION_CHANGES";
export const MARK_APPLICATION_AS_HAVING_REQUESTED_DOCUMENTS = "MARK_APPLICATION_AS_HAVING_REQUESTED_DOCUMENTS";
export const SET_IS_RETIRED_FIELD = "SET_IS_RETIRED_FIELD";
export const UNSHIFT_ELEMENT = "UNSHIFT_ELEMENT";
const mutations = {
  [SET_APPLICATION_SOURCE_TYPE]: (state, {
    applicationSourceType,
    applicationId
  }) => {
    var _context;
    Vue.set(state.applicationSourceType.byId, applicationId, applicationSourceType);
    if (!_includesInstanceProperty(_context = state.applicationSourceType.allIds).call(_context, applicationId)) {
      state.applicationSourceType.allIds.push(applicationId);
    }
  },
  [SET_APPLICATION_METADATA]: (state, {
    applicationsMetadata,
    applicationId
  }) => {
    var _context2;
    Vue.set(state.applicationsMetadata.byId, applicationId, applicationsMetadata);
    if (!_includesInstanceProperty(_context2 = state.applicationsMetadata.allIds).call(_context2, applicationId)) {
      state.applicationsMetadata.allIds.push(applicationId);
    }
  },
  [SET_CURRENT_APPLICATION_ID]: (state, {
    applicationId
  }) => {
    state.currentApplicationId = applicationId.toString();
  },
  [SET_APPLICATION]: (state, {
    applicationId,
    applicationObject
  }) => {
    var _context3;
    const applicationWithDefaults = merge(ignoreTransformWith(EmptyApplication(), value => isArray(value)), applicationObject);
    Vue.set(state.applications.byId, applicationId, applicationWithDefaults);
    if (!_includesInstanceProperty(_context3 = state.applications.allIds).call(_context3, applicationId)) {
      state.applications.allIds.push(applicationId);
    }
  },
  [SET_APPLICATION_FLOW]: (state, {
    flow
  }) => {
    const {
      currentApplicationId
    } = state;
    if (currentApplicationId) {
      state.applications.byId[currentApplicationId].flow = flow;
      state.flow = flow;
    }
  },
  [SET_CURRENT_APPLICATION_SCHEMA]: (state, {
    schema
  }) => {
    var _context4;
    const {
      currentApplicationId
    } = state;
    if (!currentApplicationId) return;
    Vue.set(state.schema.byId, currentApplicationId, schema);
    if (!_includesInstanceProperty(_context4 = state.schema.allIds).call(_context4, currentApplicationId)) {
      state.schema.allIds.push(currentApplicationId);
    }
  },
  [SET_CURRENT_COMPUTED_SCHEMA_BY_PATH]: (state, {
    path,
    visible
  }) => {
    const {
      flow
    } = state;
    Vue.set(state.currentComputedSchema[path.replace(/\[[0-9]]/g, "")].visible, flow, visible);
  },
  [SET_CURRENT_COMPUTED_SCHEMA]: (state, {
    schema
  }) => {
    Vue.set(state, "currentComputedSchema", cloneDeep(schema));
  },
  [SET_CURRENT_APPLICATION]: (state, {
    applicationObject
  }) => {
    const {
      currentApplicationId
    } = state;
    if (currentApplicationId) {
      var _context5;
      Vue.set(state.applications.byId, currentApplicationId, applicationObject);
      if (!_includesInstanceProperty(_context5 = state.applications.allIds).call(_context5, currentApplicationId)) {
        state.applications.allIds.push(currentApplicationId);
      }
    }
  },
  [SET_FIELD_BY_PATH]: (state, {
    path,
    value
  }) => {
    const {
      currentApplicationId,
      applications
    } = state;
    if (!currentApplicationId) return;
    VueSetWithPath(applications.byId[currentApplicationId], path, value);
  },
  [UNSHIFT_ELEMENT]: (state, {
    path,
    value
  }) => {
    const {
      currentApplicationId,
      applications
    } = state;
    if (!currentApplicationId) return;
    const applicationObject = applications.byId[currentApplicationId];
    const targetElement = get(applicationObject, path);
    const emptyToAdd = ignoreTransformWith(get(EmptyApplication(), _replaceAllInstanceProperty(path).call(path, /\[[0-9]+]*\]/g, "[0]"))[0], value => isArray(value));
    const valueToUse = value ? _objectSpread(_objectSpread({}, emptyToAdd), value) : emptyToAdd;
    if (targetElement) {
      targetElement.unshift(valueToUse);
    } else {
      VueSetWithPath(applicationObject, path, [valueToUse]);
    }
  },
  [ADD_ARRAY_FIELD_BY_PATH]: (state, {
    path,
    value
  }) => {
    const {
      currentApplicationId,
      applications
    } = state;
    if (!currentApplicationId) return;
    const applicationObject = applications.byId[currentApplicationId];
    const targetElement = get(applicationObject, path);
    const emptyToAdd = ignoreTransformWith(get(EmptyApplication(), _replaceAllInstanceProperty(path).call(path, /\[[0-9]+]*\]/g, "[0]"))[0], value => isArray(value));
    const valueToUse = value ? _objectSpread(_objectSpread({}, emptyToAdd), value) : emptyToAdd;
    if (targetElement) {
      targetElement.push(valueToUse);
    } else {
      VueSetWithPath(applicationObject, path, [valueToUse]);
    }
  },
  [DELETE_ARRAY_FIELD_BY_PATH]: (state, {
    path,
    index
  }) => {
    const {
      currentApplicationId,
      applications
    } = state;
    if (!currentApplicationId) return;
    const applicationObject = applications.byId[currentApplicationId];
    const targetElement = get(applicationObject, path);
    _spliceInstanceProperty(targetElement).call(targetElement, index, 1);
    VueSetWithPath(applicationObject, path, targetElement);
  },
  [SET_DISCLAIMERS]: (state, {
    disclaimers
  }) => {
    Vue.set(state, "disclaimers", disclaimers);
  },
  [CLEAR_ALL_SINS]: state => {
    var _currentApplication$m, _currentApplication$m2;
    const {
      currentApplicationId,
      applications
    } = state;
    if (!currentApplicationId) return;
    const currentApplication = applications.byId[currentApplicationId];
    const currentMainApplicantSIN = currentApplication == null ? void 0 : (_currentApplication$m = currentApplication["main-applicant"]) == null ? void 0 : (_currentApplication$m2 = _currentApplication$m["personal-details"]) == null ? void 0 : _currentApplication$m2["sin"];
    if (currentMainApplicantSIN) {
      const isFilledSIN = !!(currentMainApplicantSIN != null && currentMainApplicantSIN[1]);
      if (currentApplication["main-applicant"] && currentMainApplicantSIN) {
        currentApplication["main-applicant"]["personal-details"]["sin"] = {
          1: currentMainApplicantSIN == null ? void 0 : currentMainApplicantSIN[1],
          2: isFilledSIN ? "XXX" : "",
          3: isFilledSIN ? "XXX" : ""
        };
      }
    }
    const coapps = currentApplication["co-applicants"] || [];
    for (const [index, coapp] of _entriesInstanceProperty(coapps).call(coapps)) {
      var _coapp$personalDetai;
      const currentCoappSIN = coapp == null ? void 0 : (_coapp$personalDetai = coapp["personal-details"]) == null ? void 0 : _coapp$personalDetai["sin"];
      if (currentCoappSIN) {
        var _currentApplication$c;
        const isFilledSIN = !!currentCoappSIN[1];
        if ((_currentApplication$c = currentApplication["co-applicants"]) != null && _currentApplication$c[index]) {
          currentApplication["co-applicants"][index]["personal-details"]["sin"] = {
            1: currentCoappSIN[1],
            2: isFilledSIN ? "XXX" : "",
            3: isFilledSIN ? "XXX" : ""
          };
        }
      }
    }
  },
  [MARK_APPLICATION_AS_SUBMITTED]: state => {
    const {
      currentApplicationId: applicationId
    } = state;
    if (!applicationId) return;
    state.applicationsMetadata.byId[applicationId].applicationStatus = CLIENT_APPLICATION_STATUS.submitted;
  },
  [MARK_APPLICATION_AS_HAVING_REQUESTED_DOCUMENTS]: (state, {
    hasRequestedDocuments
  }) => {
    const {
      currentApplicationId: applicationId
    } = state;
    if (!applicationId) return;
    state.applicationsMetadata.byId[applicationId].hasRequestedDocuments = hasRequestedDocuments;
  },
  [RESET_SUBJECT_PROPERTY_EXISTING_MORTGAGES]: state => {
    const {
      currentApplicationId: applicationId
    } = state;
    if (!applicationId) return;
    const currentApplication = state.applications.byId[applicationId];
    if (currentApplication["property"]) currentApplication["property"]["existing-mortgages"] = [];
  },
  [RESET_OTHER_PROPERTIES_EXISTING_MORTGAGES]: (state, {
    otherPropertyIndex,
    applicantIndex
  }) => {
    const {
      currentApplicationId: applicationId
    } = state;
    if (!applicationId) return;
    const currentApplication = state.applications.byId[applicationId];
    const otherPropertyPath = applicantIndex === 0 ? `[main-applicant][other-properties][${otherPropertyIndex}]` : `[co-applicants][${applicantIndex - 1}][other-properties][${otherPropertyIndex}]`;
    const currentOtherProperty = get(currentApplication, otherPropertyPath);
    if (currentOtherProperty) set(currentApplication, otherPropertyPath + "[other-property-existing-mortgages]", []);
  },
  [SET_ACCEPTED_CONSENTS]: (state, acceptedConsents) => {
    Vue.set(state, "acceptedConsents", acceptedConsents);
  },
  [SET_CLIENT_DETAILS]: (state, {
    clientDetails
  }) => {
    const {
      familyName,
      givenName
    } = clientDetails;
    Vue.set(state.guestFillOutDetails, "clientDetails", _objectSpread(_objectSpread({}, state.guestFillOutDetails.clientDetails), {}, {
      familyName,
      givenName
    }));
  },
  [SET_TOKEN_DATA]: (state, {
    token
  }) => {
    Vue.set(state.guestFillOutDetails, "token", token);
    const decodedToken = decodeToken(token);
    if (!isEmpty(decodedToken)) {
      const {
        app: applicationId,
        client: clientUsername,
        coApplicant: coApplicantId
      } = decodedToken;
      Vue.set(state.guestFillOutDetails, "clientDetails", _objectSpread(_objectSpread({}, state.guestFillOutDetails.clientDetails), {}, {
        applicationId,
        clientUsername,
        coApplicantId
      }));
    }
  },
  [SET_IS_FILL_OUT]: (state, {
    isFillOut
  }) => {
    Vue.set(state, "isFillOut", isFillOut);
  },
  [SET_CONSOLIDATED_REQUEST]: (state, {
    consolidatedRequest
  }) => {
    Vue.set(state, "consolidatedRequest", consolidatedRequest);
  },
  [SET_LOADING]: (state, loading) => {
    Vue.set(state, "loading", loading);
  },
  [SET_ADDITIONAL_INFORMATION]: (state, comment) => {
    Vue.set(state, "additionalInformation", comment);
  },
  [SET_CURRENT_APPLICATION_CHANGES]: (state, currentApplicationChanges) => {
    Vue.set(state, "currentApplicationChanges", currentApplicationChanges);
  },
  [SET_IS_RETIRED_FIELD]: (state, {
    applicantIndex,
    value
  }) => {
    const {
      currentApplicationId: applicationId
    } = state;
    if (!applicationId) return;
    const currentApplication = state.applications.byId[applicationId];
    if (applicantIndex === 0 && currentApplication["main-applicant"]) currentApplication["main-applicant"]["personal-details"]["is-retired"] = value;else if (currentApplication["co-applicants"]) currentApplication["co-applicants"][applicantIndex - 1]["personal-details"]["is-retired"] = value;
  }
};
export default mutations;